







































import { Component, Prop, Vue } from 'vue-property-decorator';
import Accordion from '@/components/accordion';
import Anketa from '@/components/anketa';
import Result from '@/components/anketaresult';
import ExtButton from '@/components/ext/Button.vue';
import Spinner from '@/components/ext/Spinner_new.vue';
import Messages from '@/components/parts/messages';
import Noitem from '@/components/parts/noitem';
import { Questionnaire, ResultQuestionPayload } from './types';

@Component({
  components: {
    Accordion,
    Anketa,
    Result,
    ExtButton,
    Spinner,
    Noitem,
    Messages,
  },
})
export default class ComponentsPartsCatalogCardTabsQuestionnaire extends Vue {
  @Prop({ type: Boolean, default: false })
  auth: boolean;

  @Prop({ type: Boolean, default: false })
  error: boolean;

  @Prop({ type: Boolean, default: false })
  isAnketaLoading: boolean;

  @Prop({ type: Boolean, default: false })
  showMessage: boolean;

  @Prop({ type: String, required: false })
  noitemText: string;

  @Prop({ type: String, required: false })
  messageText: string;

  @Prop({ type: String, default: '' })
  mainDescription: string;

  @Prop({ type: Object, required: false })
  allQuestionnaire: Questionnaire;

  get formList() {
    const { allQuestionnaire } = this;
    return allQuestionnaire.formList;
  }

  get answersList() {
    const { answerList } = this.allQuestionnaire;
    return answerList;
  }

  get isAnswersList() {
    const { answersList } = this;
    return answersList.length > 0;
  }

  get description() {
    const { questionList } = this.allQuestionnaire;
    return questionList ? questionList.description : '';
  }

  get questions() {
    const { questionList } = this.allQuestionnaire;
    return questionList ? questionList.questions : [];
  }

  get isQuestions() {
    const { questions } = this;
    return questions.length > 0;
  }

  authPopup() {
    this.$router.push({
      hash: this.$util.getRouteHashAllowAuthMethod(
        this.$store.state.apiModules
      ),
    });
  }

  questionList(payload: number) {
    this.$emit('getQuestionList', payload);
  }

  formSubmit(payload: ResultQuestionPayload) {
    this.$emit('formSubmit', payload);
  }

  closeMessage() {
    this.$emit('closeWarning');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/questionnaire/Questionnaire.vue